import React,{useState,useEffect,useRef,useContext} from 'react';
import './Home.css';
import { Toaster } from 'react-hot-toast';
import { ModalFilter, ModalRealizarCobro, ModalAutorizarTramite, ModalFinalizarProceso, ModalHistorial, } from '../../utils/modals';
import { number_format } from "../../utils/utils";
import moment from "moment";
import "moment/locale/es";
import { Row,Col,Form, Button, Table, Spinner} from 'react-bootstrap';
import TablaRecibos from '../TablaRecibos/TablaRecibos';
import { useSelector,useDispatch,getState } from 'react-redux'; 
import { setInitData,setStateHome, setStateGlobal, showAlert, } from '../../reducers/appReducer';
import { RightSidebarNuevaCotizacion, } from '../RightSidebar/RightSidebar';

import { AuthContext } from '../../auth/AuthContext';
import { Navigate } from 'react-router-dom';

moment.locale("mx");

export const HomeCaja = ({typeView, socket}) => {

  const { usuario } = useContext(AuthContext);

  const stateGlobal = useSelector( (state) => state.agents );
  const stateHome = stateGlobal.home;
  const dispatch = useDispatch();
  const { 
    section, 
    showModalRecibos,
    recibosSearch,
    customDate,
    fechaInicio,
    fechaFin,
  } = stateHome;

  let { 
    dataTramite,
    showSidebarModificarOT,
  } = stateGlobal;

  const refDateToday = useRef(null);
  const refDateTomorrow = useRef(null);
  const today = moment().add(-1, 'year').format('YYYY-MM-DD');
  const tomorrow = moment(today,'YYYY-MM-DD').add(1, 'year').format('YYYY-MM-DD');
  const [state,setState] = useState({ changeTab: false });
  const [findValue,setFindValue] = useState("");

  const setSidebarModificarOT = (opt) => {
    dispatch( setStateHome( { showSidebarModificarOT: opt, } ) );
  }

  const handleSetSection = (section) => {
    const { arrSections } = stateHome
    let newSection = {...arrSections, ...section }
    dispatch( setStateHome( { arrSections: newSection } ) )
  }

  const handleSubmitSearch = (e) => {
    getTramitesByDate();
    e.preventDefault();
    getCobranza()
  }

  /** COBRANZA **/
  const [cobranza,setCobranza] = useState([]);
  const [isLoading,setIsLoading] = useState(false);
  const [date,setDate] = useState(today);
  const [dataFiltered2, setDataFiltered2] = useState([]);


  const [windowDimenion, detectHW] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  })


  const detectSize = () => {
    detectHW({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    })
  }
  
  useEffect(() => {
    window.addEventListener('resize', detectSize)
    return () => window.removeEventListener('resize', detectSize)
  }, [windowDimenion])

  const getCobranza = (dateSearch) =>{
    const data = {
      // date_start : stateHome.fechaInicio,
      // date_end : stateHome.fechaFin

      date_start : '2023-02-17',
      date_end : '2023-02-17',
    }
    setIsLoading(true);
    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=getCobranzaByDate',{
      method: 'POST',
      model: 'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json())
    .then( res => {
      setCobranza(res.documents)
      setIsLoading(false);
    } )
  }

  const searcCobranzaByDate = (e) => {
    e.preventDefault();
    setIsLoading(true);
    getCobranza(date);
  }

  useEffect(() => {
    getCobranza(date);
    dispatch(setStateHome( { 
      isLoadPanel: true,
      fechaInicio: today,
      fechaFin: tomorrow,
      customDate: true
    }));
    if(!customDate){
      dispatch( setStateHome( {
        fechaInicio: today, fechaFin: tomorrow,
        arrSections: {
          cotizaciones: true,
          orden_trabajo: true,
          caja: false,
          creditos: false,
          finanzas: false,
          procesos: false,
        }
       } ) )
    }
  },[]);

  useEffect(() => {
    if(stateHome.customDate){
      getTramitesByDate();
    }
  },[stateHome.customDate]);

  const getTramitesByDate = () =>{
    dispatch(setStateHome( { isLoadPanel: true}));
    const data = {
      date_start: refDateToday.current.value,
      date_end: refDateTomorrow.current.value 
    };
    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=getTramitesByDate',{
      method: 'POST',
      mode:'cors',
      body: JSON.stringify(data),
    })
    .then( response => response.json())
    .then( response => {
      dispatch( setStateGlobal({ dataArray: response.documents, }) )
      dispatch( setStateHome( { isLoadPanel: false}) );
    })
  }

  const getViewContrato = (dataRecibo) => {
  }

  const updateOT = () => {

    let _dataTramite = [], _tmp = dataTramite, canProcess = false
    for(var a in _tmp.arrOT[0].arrProcess) {

      if(_tmp.arrOT[0].arrProcess[a].id === 'orden_trabajo') {

        let status = 2

        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status,
        })

      } else if(_tmp.arrOT[0].arrProcess[a].id === 'procesos') {

        canProcess = _tmp.arrOT[0].arrProcess[a - 1].status === 2 ? true : false

        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status: canProcess ? 1 : 0,
        })

      } else {
        _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
      }


    }


    const arrHistory = [...dataTramite.arrOT[0].arrHistory, {
      usuario_nombre: usuario.nombre, fecha: moment().format('YYYY-MM-DD HH:mm:ss'), motivo: "Registró un nuevo cobro", id: 'caja',
    }]
    const dataUpdate = {
      info: dataTramite.arrOT[0].info,
      arrProcess: _dataTramite,
      arrHistory,
      id_tramite_ot: dataTramite.id_cotizacion,
      id_cotizacion: dataTramite.id_cotizacion,
    }

    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateTramitesOt',{
     method: 'POST',
     mode: 'cors',
     body: JSON.stringify(dataUpdate),
    })
    .then( response => response.json())
    .then( response => {
      dispatch( showAlert( {
        show : true, 
        message : 'Pago de trámite realizado con éxito',
        type: 'success',
        duration: 3000,
      } ) )
      setTimeout(() => {
        socket.emit("toCajero", { client: 'hgapp', substrace: 'updateCost', }) 
      }, 1000)
    })

  }
  const searchData = recibosSearch.toLowerCase();
  let filteredData = [];
  let dataArray = stateGlobal.dataArray;

  if (recibosSearch == "") {
    filteredData = dataArray;
  } else {
    filteredData = dataArray.filter((el) => {
      const { nombre, concepto2, created_at } = el;
      return (
        nombre?.toLowerCase().includes(searchData ) ||
        concepto2?.toLowerCase().includes(searchData ) ||
        created_at?.toLowerCase().includes(searchData)
      );
    });
  }

  // const searchData2 = findValue.toLowerCase();
  // let filteredData2 = [];
  // let dataArray2 = cobranza;
  //
  // if (recibosSearch == "") {
  //   filteredData2 = cobranza;
  // } else {
  //   filteredData2 = dataArray2.filter((el) => {
  //     // const { nombre, concepto2, created_at } = el;
  //     return (
  //       nombre.toLowerCase().includes(searchData2) ||
  //       concepto2.toLowerCase().includes(searchData2 ) ||
  //       created_at.toLowerCase().includes(searchData2)
  //     );
  //   });
  // }
  // setDataFiltered2(filteredData2);

  // const search2 = () =>{
  //   const searchData2 = find.toLowerCase();
  //   let dataArray2 = [];
  //   if (searchData2 == "") {
  //   } else {
  //     dataArray2 = cobranza.filter((el) => {
  //       // const { nombre, nombre_tipo, concepto2, cantidad } = el.arrTramite;
  //       const { cantidadRecibida, forma_pago, created_at } = el;
  //       return (
  //         // nombre.toLowerCase().includes(searchData2 ) ||
  //         // nombre_tipo.toLowerCase().includes(searchData2 ) ||
  //         // concepto2.toLowerCase().includes(searchData2 ) ||
  //         // cantidad.toLowerCase().includes(searchData2 ) ||
  //
  //         cantidadRecibida.toLowerCase().includes(searchData2 ) ||
  //         forma_pago.toLowerCase().includes(searchData2 ) ||
  //         created_at.toLowerCase().includes(searchData2)
  //       );
  //     });
  //     setFilteredData2(dataArray2)
  //   }
  // }
  

  const calculateFaltante = (faltante, arrCobranza) => {
    
    faltante = faltante.replace('$', '')
    faltante = faltante.replace(',', '')

    let totalAbonos = 0
    arrCobranza.map((t,e) => {

      totalAbonos += parseFloat(t.cantidadRecibida)

    })

    return "$" + number_format(faltante - totalAbonos)

  }

  if(usuario.logged){
    if(usuario.tipo_usuario!=='2'){
        return <Navigate to="/login" />
    }
  }

  const ver = 0

  return (
    <div className="container-fluid">
  
      <div className="ws-main-container container-fluid">
        {/* Filtros */}
        <div className="ws-tab-container pb-3">
          {/* Tab section */}
          <Row>
            <Col>
              {/* Formulario de búsqueda por rango de fecha */}
              <Form onSubmit={handleSubmitSearch} className="d-flex align-items-end flex-md-row gap-2 ws-main-datebar">
                {(typeView === 'homeCaja' && windowDimenion.winWidth >= windowDimenion.winHeight) && <Button onClick={() => { dispatch( setStateGlobal({ showModalRealizarCobro: 2, }) ) }} className="ws-btn-blue-2 ws-main-add-cotizacion">MÚLTIPLES PAGOS</Button>}
                <Form.Group className="mb-1">
                  <Form.Control ref={refDateToday} type="date" defaultValue={fechaInicio} />
                </Form.Group>
                <Form.Group className="mb-1">
                  <Form.Control ref={refDateTomorrow} type="date" defaultValue={fechaFin} />
                </Form.Group>
                <Form.Group className="mb-1">
                  <Button type="submit" className="ws-btn-blue-2">&nbsp;&nbsp;<i className="bi bi-search pe-2"></i>{ windowDimenion.winWidth > windowDimenion.winHeight &&( "Buscar") }</Button>
                </Form.Group>
              </Form>
              <br />
              {/*<Button onClick={() => { dispatch( setStateGlobal({ showModalRealizarCobro: 2, }) ) }} className="ws-btn-blue-2 ws-main-add-cotizacion">MÚLTIPLES PAGOS</Button>*/}
            </Col>
          </Row>
          {/* Formulario de búsqueda por filtro ingresado */}
          <Row className="mt-3">
            <Col xs={12}> 
              <Form onSubmit={ (e) => e.preventDefault() }>
                <Form.Group className="group-search">
                  <i className="bi bi-search pe-2"></i>
                  <Form.Control 
                  type="search"
                  className="ws-input-search"
                  placeholder="Filtrar por nombre, trámite, fecha..."
                  value={recibosSearch}
                  onChange={ (e) => dispatch(setStateHome({recibosSearch: e.target.value})) }
                  />
                </Form.Group>
              </Form>
            </Col>
          </Row>
        </div>
        {/* TABLA DE LOS RECIBOS */}
        <TablaRecibos 
        state={state} 
        setState={setState}
        filteredData={filteredData} 
        typeView={typeView}
        />
        {
          ver === 1 &&
          <>
            <Form onSubmit={ (e) => e.preventDefault() }>
              <Form.Group className="group-search mb-3">
                <i className="bi bi-search pe-2"></i>
                <Form.Control 
                  type="search"
                  className="ws-input-search"
                  placeholder="Filtrar por nombre, trámite, fecha..."
                  onChange={ (e) => {
                    setFindValue(e.target.value)
                  }}
                />
              </Form.Group>
            </Form>
            <Row>
              <Col xs={12}>
                <div className="ws-box-container">
                  
              { isLoading && (
                  <div className="ws-loader-container">
                    <Spinner animation="border" variant="danger" size="lg"/>
                  </div>) }
                  <Table responsive hover>
                    <thead>
                      <tr>
                        <th width="20%">Cliente / Trámite</th>
                        <th width="20%">Cantidad a pagar</th>
                        <th width="20%">Cantidad recibida</th>
                        <th width="20%">Recibido en</th>
                        <th width="20%">Fecha</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        (cobranza.length>0) ? 
                          cobranza.map((t,e) => (
                            <tr key={`list-${e}`}>
                              <td style={{ padding: '15px 0', }}>
                                <p style={{ margin: 0, }}><b>{t.arrTramite.nombre}</b></p>
                                <p style={{ margin: 0, }}>{t.arrTramite.nombre_tipo}</p>
                                <p style={{ margin: 0, }}>{t.arrTramite.concepto2}</p>
                              </td>
                              <td style={{ padding: '15px 0', textAlign: 'center', }}>${number_format(t.arrTramite.cantidad, 2)}</td>
                              <td style={{ padding: '15px 0', textAlign: 'center', }}>{(t.cantidadRecibida!=='') ? `$${number_format(t.cantidadRecibida)}` : t.cantidadRecibida}</td>
                              <td style={{ padding: '15px 0', textAlign: 'center', }}>{t.forma_pago}</td>
                              <td style={{ padding: '15px 0', }}>{t.created_at}</td>
                            </tr>
                          ))
                        : 
                        <tr>
                          <td colSpan={5} className="text-center"><p className="mt-2" style={{color:'#333'}}>No hay resultados</p></td>
                        </tr>
                      }
                    </tbody>
                  </Table> 
                </div>
              </Col>
            </Row>
          </>
        }

        {/* Modals */}
        
        <ModalRealizarCobro socket={socket} handleClose={ () => {
          dispatch( setStateGlobal({ showModalRealizarCobro: false, }))
        }} filteredData={filteredData} />  
        <ModalAutorizarTramite socket={socket} handleClose={ () => {
          dispatch( setStateGlobal({ showModalAutorizarTramite: false, }))
        }} />  
        <ModalFinalizarProceso socket={socket} handleClose={ () => {
          dispatch( setStateGlobal({ showModalFinalizarProceso: false, }))
        }} />  
        <ModalHistorial socket={socket} handleClose={ () => {
          dispatch( setStateGlobal({ showModalHistorial: false, }))
        }} />  
 
        {/* TOAST NOTIFICATION */}
        <Toaster position='top-right' />

        <RightSidebarNuevaCotizacion status={showSidebarModificarOT} setStatus={() => setSidebarModificarOT(true)} title="Modificar orden de trabajo" onClose={() => { window.location.reload() }} onSave={ () => updateOT() } >
          <Form>
            <Row className="ws-form-group-divider pb-3 pt-3">
              {
                dataTramite.arrOT && dataTramite.arrOT[0].info.map((t,e) => (
                  <Col key={`list-${e}`} xs={12} lg={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="ws-form-label">  
                        {t.nombre}
                      </Form.Label>
                      <Form.Control name={t.id} type={t.tipo} multiple={(t.tipo==='file') ? true : false}
                      onChange={ (ev) => {

                        /*
                        dataTramite.arrOT[0].info[e].value = ev.target.value

                        const newData = {...dataTramite}
                        const newObj = newData.formulario.map((element) => {
                          if(element.id===t.id){
                            if(t.tipo==='file'){
                              t.value = ev.target.files;
                            }else{
                              t.value = ev.target.value
                            }
                          }
                          return element;
                        })
                        */

                       } }
                      />
                    </Form.Group>
                  </Col>
                ))
              }
              <hr />

            </Row>
          </Form>
        </RightSidebarNuevaCotizacion>



      </div>
    </div>
  )
}
